var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", { staticClass: "my-bookmark__info" }, [
    _c("span", { staticClass: "ico-bookmark" }),
    _vm._v(" "),
    _c("span", [_vm._v("북마크한 글")]),
    _vm._v(" "),
    _c("em", [_vm._v(_vm._s(_vm.count))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }